import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectEventDTOSubtype } from 'flow/selectors/TicketEventSelectors';
import { TicketKey } from 'flow/types/EntityKeys';
import { TicketActionEventKey } from 'flow/types/TicketEventData';
import ActionEventAssigneeChanged from './ActionEventAssigneeChanged';
import ActionEventStateChanged from './ActionEventStateChanged';
import ActionEventSubjectChanged from './ActionEventSubjectChanged';

interface Props {
    ticketKey: TicketKey;
    eventKey: TicketActionEventKey;
}

const EventTicketAction = ({ ticketKey, eventKey }: Props) => {
    const dtoSubtype = useAppSelector((state) =>
        selectEventDTOSubtype(state, ticketKey, eventKey),
    );

    if (dtoSubtype === 'OmniAssigneeChangedEvent') {
        return (
            <ActionEventAssigneeChanged
                ticketKey={ticketKey}
                eventKey={eventKey}
            />
        );
    }
    if (dtoSubtype === 'OmniStateChangedEvent') {
        return (
            <ActionEventStateChanged
                ticketKey={ticketKey}
                eventKey={eventKey}
            />
        );
    }
    if (dtoSubtype === 'OmniSubjectChangedEvent') {
        return (
            <ActionEventSubjectChanged
                ticketKey={ticketKey}
                eventKey={eventKey}
            />
        );
    }
    return null;
};

export default React.memo(EventTicketAction);
